import { DataTableFilter } from '@/types/DataTable'
import { computed, Ref, ref } from 'vue'

interface TextFilterPayload {
  label: string
  field: string
  icon?: string
  required: boolean
}

export function useTextFilter({
  label,
  field,
  icon,
  required,
}: TextFilterPayload): DataTableFilter<string> {
  const loading = ref(false)

  const model: Ref<string | null> = ref(null)

  const ready = Promise.resolve(true)

  return {
    model,
    value: computed(() => model.value),
    label,
    field,
    icon,
    type: 'text',
    loading,
    ready,
    required,
  }
}
